import { PrimaryDonateButton, PrimaryDonateLink } from './Button/Primary/Donate/Donate.styled';
import { PrimaryBrandButton, PrimaryBrandLink } from './Button/Primary/Brand/Brand.styled';
import { SecondaryBrandButton, SecondaryBrandLink } from './Button/Secondary/Brand/Brand.styled';
import { TertiaryDestructiveButton, TertiaryDestructiveLink } from './Button/Tertiary/Destructive/Destructive.styled';
import { TertiaryNeutralButton, TertiaryNeutralLink } from './Button/Tertiary/Neutral/Neutral.styled';
import { TextButton } from './Text/TextButton';
import { IconButton } from './Icon/IconButton';

/**
 * Prefer dot-notation imports.
 * <Button.PrimaryDonate/>
 * <Button.Text/>
 * etc.
 */
export const Button = {
  PrimaryDonate: PrimaryDonateButton,
  PrimaryBrand: PrimaryBrandButton,
  SecondaryBrand: SecondaryBrandButton,
  TertiaryNeutral: TertiaryNeutralButton,
  TertiaryDestructive: TertiaryDestructiveButton,
  Text: TextButton,
  Icon: IconButton
};

/**
 * The following is necessary to ensure Storybook's code panel shows the correct component names.
 */
Button.PrimaryDonate.displayName = 'Button.PrimaryDonate';
Button.PrimaryBrand.displayName = 'Button.PrimaryBrand';
Button.SecondaryBrand.displayName = 'Button.SecondaryBrand';
Button.TertiaryNeutral.displayName = 'Button.TertiaryNeutral';
Button.TertiaryDestructive.displayName = 'Button.TertiaryDestructive';
/* @ts-expect-error EmotionJSX.Element does not include displayName for some reason */
Button.Text.displayName = 'Button.Text';
/* @ts-expect-error EmotionJSX.Element does not include displayName for some reason */
Button.Icon.displayName = 'Button.Icon';

/**
 * Prefer dot-notation imports.
 * <Link.PrimaryDonate/>
 * <Link.TertiaryDestructive/>
 * etc.
 */
export const Link = {
  PrimaryDonate: PrimaryDonateLink,
  PrimaryBrand: PrimaryBrandLink,
  SecondaryBrand: SecondaryBrandLink,
  TertiaryNeutral: TertiaryNeutralLink,
  TertiaryDestructive: TertiaryDestructiveLink
};

/**
 * The following is necessary to ensure Storybook's code panel show the correct component names.
 */
Link.PrimaryDonate.displayName = 'Link.PrimaryDonate';
Link.PrimaryBrand.displayName = 'Link.PrimaryBrand';
Link.SecondaryBrand.displayName = 'Link.SecondaryBrand';
Link.TertiaryNeutral.displayName = 'Link.TertiaryNeutral';
Link.TertiaryDestructive.displayName = 'Link.TertiaryDestructive';